import React, { useState, useEffect } from "react";
import { isPWA } from "utils/isPWA";

const LOGO = "/logo-goldenclover.webp";
const COIN = "/icon-goldenclover.webp";
const SESSION_KEY = "goldenclover_splash_shown";

// Five horizontal positions (in %) for the cascading clover coins.
const COIN_POSITIONS = [12, 31, 50, 69, 88];

// PWA-only animated splash screen with a clover coin cascade, shown once per session.
const SplashScreen = () => {
  // Compute visibility synchronously so the opaque emerald splash is present in
  // the component's very first render/paint (no useEffect mount delay), which is
  // what otherwise lets the app underneath flash through. Shown once per session
  // in installed PWA mode.
  const [visible, setVisible] = useState(
    () => isPWA() && sessionStorage.getItem(SESSION_KEY) !== "true"
  );
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (!visible) return undefined;

    sessionStorage.setItem(SESSION_KEY, "true");

    // Begin fade-out at 3000ms, then unmount after the 500ms transition.
    const fadeTimer = setTimeout(() => setFadingOut(true), 3000);
    const hideTimer = setTimeout(() => setVisible(false), 3500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className={"gcc-splash" + (fadingOut ? " gcc-splash--out" : "")}>
      <div className="gcc-splash__coins" aria-hidden="true">
        {COIN_POSITIONS.map((left, index) => (
          <img
            key={index}
            src={COIN}
            alt=""
            className="gcc-splash__coin"
            style={{ left: left + "%", animationDelay: index * 150 + "ms" }}
          />
        ))}
      </div>

      <div className="gcc-splash__brand">
        <img src={LOGO} alt="Golden Clover Casino" className="gcc-splash__logo" />
        <p className="gcc-splash__tagline">The best chances of winning big!</p>
      </div>
    </div>
  );
};

export default SplashScreen;
